// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setPageName } from "../../../../services/pageService/pageActionCreator";
import { pageObj, categorySettingsPages } from "./categorySettingsHelper";
import ComponentWithSideMenu from "../../../commons/componentWithSideMenu/componentWithSideMenu";
import IframeWrapper from "../../../commons/iframeWrapper/iframeWrapper";
import CategoryDetails from "./categoryDetails/categoryDetails";
import CreateCategory from "./createCategory/createCategory";
import IssueType from "./issueType/issueType";
import styles from "./categorySettings.scss";
import Loader from "../../../commons/loader/loader";
import {
  getGroupTypesByBu,
  getTicketTypesByBuAndGroupType,
  deleteIssue
} from "./categorySettingsRedux/categorySettingsActionCreator";

type Props = {
  userProfile: Object,
  setPageName: Function,
  getGroupTypesByBu: Function,
  categorySettingsState: Object,
  getTicketTypesByBuAndGroupType: Function,
  deleteIssue: Function
};

type State = {
  selectedCategory: Object,
  selectedPage: String,
  issueData: Object
};

class CategorySettings extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      selectedCategory: null,
      selectedPage: categorySettingsPages.TUTORIAL,
      issueData: null
    };
  }

  componentDidMount() {
    this.props.setPageName(pageObj);
    this.props.getGroupTypesByBu(
      this.props.userProfile.business_unit &&
        this.props.userProfile.business_unit.id
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.categorySettingsState.category &&
      nextProps.categorySettingsState.category !==
        this.props.categorySettingsState.category
    ) {
      this.props.getGroupTypesByBu(
        this.props.userProfile.business_unit &&
          this.props.userProfile.business_unit.id
      );
    } else if (
      this.props.categorySettingsState.groupTypes.data !==
      nextProps.categorySettingsState.groupTypes.data
    ) {
      if (
        nextProps.categorySettingsState.groupTypes.data &&
        nextProps.categorySettingsState.groupTypes.data.length
      ) {
        this.selectOption(nextProps.categorySettingsState.groupTypes.data[0]);
      }
    }
  }

  onBackPressed() {
    if (
      this.props.categorySettingsState.groupTypes.data &&
      this.props.categorySettingsState.groupTypes.data.length
    ) {
      this.selectOption(this.props.categorySettingsState.groupTypes.data[0]);
    } else {
      this.setState({
        selectedPage: categorySettingsPages.TUTORIAL
      });
    }
  }

  editCategory(category) {
    this.setState({
      selectedCategory: category,
      selectedPage: categorySettingsPages.CREATE_CATEGORY
    });
  }

  selectOption(val) {
    this.setState(
      {
        selectedCategory: val,
        selectedPage: categorySettingsPages.CATEGORY_DETAILS
      },
      () => {
        this.props.getTicketTypesByBuAndGroupType(
          this.props.userProfile.business_unit &&
            this.props.userProfile.business_unit.id,
          this.state.selectedCategory.id
        );
      }
    );
  }

  selectTopOption() {
    this.setState({
      selectedCategory: null,
      selectedPage: categorySettingsPages.CREATE_CATEGORY
    });
  }

  deleteIssue(rowData) {
    const formData = {
      id: rowData.id
    };
    // eslint-disable-next-line
    console.log("Hitting API ", formData);

    this.props.deleteIssue(formData);
    this.setState({
      selectedPage: categorySettingsPages.TUTORIAL
    });
  }

  editIssue(rowData) {
    this.setState({
      selectedCategory: this.state.selectedCategory,
      selectedPage: categorySettingsPages.ISSUE_TYPE,
      issueData: rowData
    });
  }

  createIssue() {
    this.setState({
      selectedCategory: this.state.selectedCategory,
      selectedPage: categorySettingsPages.ISSUE_TYPE,
      issueData: null
    });
  }

  renderCreateCategoryPage() {
    return (
      <div>
        <CreateCategory
          onBack={() => this.onBackPressed()}
          categoryData={this.state.selectedCategory}
        />
      </div>
    );
  }

  renderCategoryDetails(groupType) {
    return (
      <div>
        <CategoryDetails
          category={groupType}
          onEditCategory={category => this.editCategory(category)}
          onEditIssue={rowData => this.editIssue(rowData)}
          onDeleteIssue={rowData => this.deleteIssue(rowData)}
          createIssue={() => this.createIssue()}
        />
      </div>
    );
  }

  renderTutorial() {
    return (
      <div>
        <div className={styles.tutorialHeading}>Tutorials</div>
        <IframeWrapper
          url="https://www.youtube.com/embed/Ntt0pv0d6p4"
          utils={{
            width: "100%",
            height: "100%"
          }}
          isFetching={false}
        />
      </div>
    );
  }

  renderIssueTypePage() {
    return (
      <IssueType
        onBack={() => this.onBackPressed()}
        ticketTypeDTO={this.state.issueData}
        groupType={this.state.selectedCategory}
      />
    );
  }

  render() {
    const { groupTypes } = this.props.categorySettingsState;
    if (!groupTypes.isLoaded) {
      return <Loader />;
    }
    return (
      <ComponentWithSideMenu
        menuOptions={groupTypes.data}
        selectOption={option => this.selectOption(option)}
        topOption="+ Create Category"
        selectTopOption={option => this.selectTopOption(option)}
      >
        <div className={styles.currentMenuWrapper}>
          {this.state.selectedPage === categorySettingsPages.TUTORIAL
            ? this.renderTutorial()
            : null}
          {this.state.selectedPage === categorySettingsPages.CATEGORY_DETAILS &&
          this.state.selectedCategory &&
          groupTypes.data.length
            ? this.renderCategoryDetails(this.state.selectedCategory)
            : null}
          {this.state.selectedPage === categorySettingsPages.CREATE_CATEGORY
            ? this.renderCreateCategoryPage()
            : null}
          {this.state.selectedPage === categorySettingsPages.ISSUE_TYPE
            ? this.renderIssueTypePage()
            : null}
        </div>
      </ComponentWithSideMenu>
    );
  }
}

const mapStateToProps = state => ({
  userProfile: state.userProfile,
  categorySettingsState: state.categorySettingsState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getGroupTypesByBu: bindActionCreators(getGroupTypesByBu, dispatch),
  getTicketTypesByBuAndGroupType: bindActionCreators(
    getTicketTypesByBuAndGroupType,
    dispatch
  ),
  deleteIssue: bindActionCreators(deleteIssue, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CategorySettings);



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/categorySettings/categorySettings.js